import { AppDispatch, RootState } from "init/providers/ReduxProvider";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

/**
 * Typed redux hooks
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
